export class BenefitValuesModel {
  [key: string] : number;

  nightDriver: number = 0;
  defaultDriver: number = 0;
}
